"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactUsSummary = void 0;
exports.ContactUsTray = ContactUsTray;
exports.trayLabelStyles = exports.TrayContent = exports.Tray = exports.ContactUsTrayMenu = exports.ContactUsTrayContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _contactUsTrayPanelGroup = require("./contact-us-tray-panel-group");
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-len */

const CHATNOWID = 'gdchat-container';
const ContactUsTrayContainer = exports.ContactUsTrayContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContactUsTrayContainer",
  class: "pl-c1x0dm2x"
});
const contactUsClosed = "pl-cm0om50";
const contactUsOpen = "pl-c111k8sh";
const ContactUsSummary = exports.ContactUsSummary = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "ContactUsSummary",
  class: "pl-cqrhhkp"
});
const trayLabelStyles = exports.trayLabelStyles = "pl-tee4rfw";
const Tray = exports.Tray = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Tray",
  class: "pl-t1m53y9m"
});
const TrayContent = exports.TrayContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrayContent",
  class: "pl-t1le35ql"
});
const ContactUsTrayMenu = exports.ContactUsTrayMenu = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContactUsTrayMenu",
  class: "pl-cl2gmiu"
});

/**
 * Account Tray component.
 * @param {Object} props React props
 * @param {string} trayLabel Tray Label
 * @param {string} chatNowLabel ChatNow Label
 * @param {string} chatNowContent ChatNow Content
 * @param {string} chatNowOffline ChatNow Offline
 * @param {string} chatNowHours ChatNow Hours
 * @param {string} ariaLabel Aria Label
 * @param {array} groups Menus with links
 * @param {React.ReactElement} ctas CTAs
* @returns {React.ReactElement} Help Center Tray
 * @public
 */

function ContactUsTray({
  _name,
  id,
  trayLabel,
  trayIcon,
  ariaLabel,
  groups,
  chatNowLabel,
  chatNowContent,
  chatNowOffline,
  chatNowHours,
  chatNowExample,
  invert,
  partial
}) {
  const [trayOpen, setTrayOpen] = (0, _react.useState)(false);
  const contactUsButtonRef = (0, _react.useRef)(null);
  const contactUsTrayRef = (0, _react.useRef)(null);
  const handleClick = ({
    target
  }) => {
    if (contactUsButtonRef.current.contains(target)) {
      return;
    }
    if (contactUsTrayRef.current.contains(target)) {
      setTrayOpen(true);
      return;
    }
    setTrayOpen(false);
  };
  const toggleTray = () => {
    setTrayOpen(!trayOpen);
  };
  const handleEscape = ({
    code
  }) => {
    if (trayOpen === true && code === 'Escape') {
      setTrayOpen(false);
      contactUsButtonRef.current.focus();
    }
  };
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('mousedown', handleClick);
      document.addEventListener('keydown', handleEscape);
      return () => {
        document.removeEventListener('mousedown', handleClick);
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [trayOpen]);
  (0, _react.useEffect)(() => {
    if (!window.utag_data) {
      window.utag_data = {};
    }
    // eslint-disable-next-line dot-notation
    window.utag_data['app_name'] = 'sales';
    window.ux = window.ux || {};
    window.ux.eldorado = window.ux.eldorado || {};
    window.ux.eldorado.chat_data = {
      target: CHATNOWID,
      utilityChatEnabled: true,
      messages: {
        ChatNow: chatNowLabel,
        Chat: chatNowContent,
        ChatOffline: chatNowOffline,
        ChatHours: chatNowHours
      }
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(ContactUsTrayContainer, {
    id: `${id}`,
    "data-cy": "contact-us-tray"
  }, /*#__PURE__*/_react.default.createElement(ContactUsSummary, {
    className: `toggle ${contactUsClosed} ${trayOpen ? contactUsOpen : ''}`,
    ref: contactUsButtonRef,
    "aria-label": ariaLabel,
    tabIndex: "0",
    onClick: toggleTray,
    isOpen: trayOpen,
    "data-partial": partial || (invert ? 'dark1' : 'light1')
  }, /*#__PURE__*/_react.default.createElement(_text.default.span, {
    as: "paragraph",
    className: trayLabelStyles,
    size: -1
  }, trayLabel, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-down",
    fill: trayOpen ? _intents.default.ux.navigatePrimaryChosen.foregroundColor : _intents.default.ux.navigatePrimary.foregroundColor
  })), /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: trayIcon,
    fill: trayOpen ? _intents.default.ux.navigatePrimaryChosen.foregroundColor : _intents.default.ux.navigatePrimary.foregroundColor
  })), /*#__PURE__*/_react.default.createElement(Tray, {
    "data-partial": "light1",
    tabIndex: "-1",
    "data-cy": "tray-panel",
    className: `tray-panel ${trayOpen ? 'open' : 'close'}`,
    ref: contactUsTrayRef
  }, /*#__PURE__*/_react.default.createElement(TrayContent, null, /*#__PURE__*/_react.default.createElement(ContactUsTrayMenu, {
    _name: _name,
    dataCy: "contact-us-menu"
  }, groups?.map((group, i) => /*#__PURE__*/_react.default.createElement(_contactUsTrayPanelGroup.ContactUsTrayPanelGroup, (0, _extends2.default)({
    key: i
  }, group))), chatNowExample && /*#__PURE__*/_react.default.createElement(_contactUsTrayPanelGroup.ContactUsTrayPanelGroup, {
    chatNowId: CHATNOWID,
    chatNowExample: chatNowExample
  })))));
}
ContactUsTray.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  trayIcon: _propTypes.default.oneOf(['phone', 'comment']),
  trayLabel: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  groups: _propTypes.default.array,
  chatNowLabel: _propTypes.default.string,
  chatNowContent: _propTypes.default.string,
  chatNowOffline: _propTypes.default.string,
  chatNowHours: _propTypes.default.string,
  chatNowExample: _propTypes.default.object,
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string
};